export default function Services() {
  const services = [
    {
      title: 'Basement Waterproofing',
      description: 'Comprehensive basement waterproofing solutions that prevent water intrusion and protect your foundation. We provide permanent solutions to real problems that will leave you with a waterproof basement.',
      image: 'https://static.wixstatic.com/media/0184a2_0e4bf44f90cf455d8b2d6a2abd8450cb~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/0184a2_0e4bf44f90cf455d8b2d6a2abd8450cb~mv2.jpg',
      icon: 'ri-home-4-line',
      features: ['Interior & Exterior Solutions', 'Sump Pump Systems', 'Drainage Installation']
    },
    {
      title: 'Crawl Space Encapsulation',
      description: 'Seal and protect your home from unwanted moisture and toxins in the soil. Improve your indoor air quality with crawl space encapsulation and waterproofing solutions that work.',
      image: 'https://static.wixstatic.com/media/0184a2_11b9d45baf2d4bc7848cfbf437a7a0e1~mv2_d_3472_2604_s_4_2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/0184a2_11b9d45baf2d4bc7848cfbf437a7a0e1~mv2_d_3472_2604_s_4_2.jpg',
      icon: 'ri-shield-line',
      features: ['Vapor Barriers', 'Moisture Control', 'Mold Prevention']
    },
    {
      title: 'Foundation Repair',
      description: 'Expert foundation repair services to stabilize and protect your home\'s structural integrity. We address cracks, settling, and water damage with proven techniques.',
      image: 'https://static.wixstatic.com/media/f7a16d_5e87cac436234f7a87f1fab9dc855f1a~mv2_d_2560_1440_s_2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Resized952016112595120717958138001002003.jpg',
      icon: 'ri-tools-line',
      features: ['Crack Repair', 'Foundation Stabilization', 'Structural Support']
    },
    {
      title: 'Sump Pump Installation',
      description: 'Professional sump pump installation and maintenance to keep your basement dry. We install reliable systems that automatically remove water before it becomes a problem.',
      image: 'https://static.wixstatic.com/media/0184a2_0e4bf44f90cf455d8b2d6a2abd8450cb~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/0184a2_0e4bf44f90cf455d8b2d6a2abd8450cb~mv2.jpg',
      icon: 'ri-water-flash-line',
      features: ['Battery Backup Systems', 'Maintenance Plans', 'Emergency Service']
    },
    {
      title: 'French Drains & Drainage Solutions',
      description: 'Custom drainage systems designed to redirect water away from your foundation. Prevent water accumulation and protect your property with professional drainage solutions.',
      image: 'https://static.wixstatic.com/media/f7a16d_5e87cac436234f7a87f1fab9dc855f1a~mv2_d_2560_1440_s_2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/Resized952016112595120717958138001002003.jpg',
      icon: 'ri-drop-line',
      features: ['French Drain Installation', 'Surface Drainage', 'Downspout Extensions']
    },
    {
      title: 'Dry-Rot Repair',
      description: 'When dry-rot and termite damage are identified, they can become a nightmare. We have the experience to replace unsafe, damaged areas in a timely manner while keeping you informed.',
      image: 'https://static.wixstatic.com/media/0184a2_3cb8677424084a4696994efdd7d9946b~mv2.jpg/v1/fill/w_600,h_400,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/0184a2_3cb8677424084a4696994efdd7d9946b~mv2.jpg',
      icon: 'ri-hammer-line',
      features: ['Subfloor Replacement', 'Structural Repairs', 'Preventive Treatment']
    }
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Our <span className="text-teal-600">Waterproofing Services</span>
          </h2>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto">
            Comprehensive moisture protection solutions for residential and commercial properties
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <article
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-slate-100 hover:-translate-y-2"
            >
              {/* Image */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center shadow-lg">
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-sm text-slate-600 mb-4 leading-relaxed">
                  {service.description}
                </p>

                {/* Features */}
                <ul className="space-y-2 mb-4">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center text-sm text-slate-700">
                      <i className="ri-check-line text-teal-600 mr-2"></i>
                      {feature}
                    </li>
                  ))}
                </ul>

                {/* CTA */}
                <a
                  href="#contact"
                  className="inline-flex items-center text-sm font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Learn More
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
